import { Link } from "react-router-dom";

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20entertainment%20media%20studio%20with%20vibrant%20neon%20accent%20lights%2C%20modern%20content%20creation%20atmosphere%2C%20dark%20background%20with%20colorful%20glowing%20elements%2C%20professional%20broadcast%20style%2C%20cinematic%20composition%2C%20warm%20and%20cool%20contrasting%20tones%2C%20no%20text%20no%20people%20abstract%20digital%20art&width=1600&height=900&seq=51chigua-hero&orientation=landscape"
          alt="51吃瓜网站 - 娱乐八卦内容平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/60"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
          <span className="bg-gradient-to-r from-rose-400 to-orange-400 bg-clip-text text-transparent">
            51吃瓜
          </span>
          <span className="block text-2xl md:text-3xl lg:text-4xl mt-2">聚焦每日热点，满足深度吃瓜</span>
        </h1>
        <p className="text-white/80 text-sm md:text-lg max-w-2xl mb-6 md:mb-8 leading-relaxed">
          每日大赛、台北娜娜、莫里秀、玩偶姐姐等热门系列，最新合集与高清视频资源一网打尽
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/daily-contest"
            className="px-6 py-3 bg-rose-500 hover:bg-rose-600 text-white font-medium rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
          >
            探索每日大赛
          </Link>
          <Link
            to="/category/collection"
            className="px-6 py-3 bg-white/10 hover:bg-white/20 text-white border border-white/30 font-medium rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
          >
            查看视频合集
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black/40 to-transparent"></div>
    </section>
  );
}